import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedShowcase.meta';

export type UseTrackViewedShowcaseParams = {
  showcase_id: string;
  short_url_id: string;
};

export const useTrackViewedShowcase = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedShowcase = useCallback(
    (params: UseTrackViewedShowcaseParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackViewedShowcase };
};
